import React from "react";
import Update from "modules/translations/components/Update";

const TranslationsUpdatePage = () => {
  return (
    <div>
      <Update />
    </div>
  );
};

export default TranslationsUpdatePage;
